import { useState, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import moment from "moment";

import { Breadcrumb, Button } from 'antd';
import { HomeOutlined } from "@ant-design/icons";
import { isEmailAddressValid } from "utils/helpers";

import { BreadcrumbRoute } from 'store/breadcrumb/actions';

import './index.scss';

interface BreadcrumbProps {
  routes: any,
  currentPath: any,
  breadcrumb: any,
  updateBreadcrumb(payload: any): any,
}

const Breadcrumbs = (props: BreadcrumbProps) => {

  const [breadcrumbs, setBreadcrumbs] = useState<any[]>([]);
  const location: any = useLocation();
  const history: any = useHistory();

  useEffect(() => {
    // This is to check for the user profile every 6 months
    const IS_SIX_MONTH_DIFF = moment().diff(moment(sessionStorage.getItem('modified_date')), 'months', true) > 6 ? true : false;
    const EMAIL = isEmailAddressValid(sessionStorage.getItem('email'));

    // These pages won't show the breadcrumb
    if (['/','/login', '/logout', '/quality/overview'].includes(props.currentPath) || IS_SIX_MONTH_DIFF || !EMAIL) {
      return;
    } else {
      try {
        getBreadcrumbs();
      } catch {
        // 404 page
        return;
      }
    }

	}, []);

  const getBreadcrumbs = () => {
    /**
     * These pages pass prop data to another component. Example here is eligibility detail page
     * that will get the breadcrumb with the prop data from the history state.
     * The breadcrumbs contain the data state that is needed to go back to the detail page.
     *
     * Otherwise, just read the breadcrumbs from the route file and persist them.
     */
    if (['/eligibility/pacp', '/eligibility/pacn', '/eligibility/claim-final-submission'].includes(props.currentPath)) {
      setBreadcrumbs(props.updateBreadcrumb(location.state.breadcrumbs));
    } else {
      const currentRoute = props.routes.find((route: BreadcrumbRoute) => props.currentPath === route.pathname);
      setBreadcrumbs(props.updateBreadcrumb(currentRoute.breadcrumbs));
    }
  }

  if(!breadcrumbs || breadcrumbs.length <= 1) return null;

  return (
    <Breadcrumb>
      {
        breadcrumbs.map((crumb: any, key: number) =>
          key + 1 === breadcrumbs.length ? (
            <Breadcrumb.Item key={key}>
              <span>{crumb.icon} </span>
              {crumb.name}
            </Breadcrumb.Item>
          ) : (
            <Breadcrumb.Item key={key}>
              {crumb.pathname === '/quality/overview' ?
                  (
                    <Link to={crumb} key={key}>
                      <HomeOutlined />
                    </Link>
                  ) :
                  (
                    <>
                      {(crumb.pathname === '/eligibility/search' && breadcrumbs.length === 3)? (
                        <>
                          <span>{crumb.icon} </span>
                          <Button type="link" className="history-back-link" onClick={() => history.push('/eligibility/search') } key={key}>
                            {crumb.name}
                          </Button>
                        </>
                      ) : (
                        <>
                          <span>{crumb.icon} </span>
                          <Link to={crumb} key={key}>
                            {crumb.name}
                          </Link>
                        </>
                      )}
                  </>
                )
              }
            </Breadcrumb.Item>
          )
        )
      }
    </Breadcrumb>
  );
}

export default Breadcrumbs;